(function () {
  'use strict';

  /* @ngdoc object
   * @name monthlyFlightTime
   * @description
   *
   */
  angular
    .module('monthlyFlightTime', [
      'ui.router'
    ]);
}());
